import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Component/Navbar';
import Officers from './Component/Pages/Officers';
import Sponsors from './Component/Pages/Sponsors';
import MakerGarage from './Component/Pages/MakerGarage';
import Events from './Component/Pages/Events';
import Home from './Component/Pages/Home';
import Footer from './Component/Footer';

function App() {
  return (
    <div>
      <Router>
        <Navbar/>
        <Routes>
          <Route path="/" element={<Home/>}></Route>
          <Route path="/officers" element={<Officers/>}></Route>
          <Route path="/sponsors" element={<Sponsors/>}></Route>
          <Route path="/maker_garage" element={<MakerGarage/>}></Route>
          <Route path="/events" element={<Events/>}></Route>
        </Routes>
        <Footer/>
      </Router>
    </div>
  );
}

export default App;
